import angular from "angular";

import HomeModuleRouting from "./home.module.routing";
import BaseRouteConfig from "../../../base-route-config";

export default angular
    .module("vt-public-home", [])
    .config(BaseRouteConfig)
    .config(HomeModuleRouting);
